import axiosInstance from "./axiosInstance";

// GET all Home
export const getSetting = async () => {
  try {
    const response = await axiosInstance.get("/setting");
    return response.data.data; 
  } catch (error) {
    console.error("Failed to fetch Setting:", error);
    throw error;
  }
};

